module.exports = __webpack_public_path__ + "img/let-that-shit-go_B09K26CGRG.0f98487a.jpg";